<template>
	<el-dialog
		title="设置"
		:visible.sync="opeartionFlag"
		width="600px"
		custom-class="opearteDialog-wrap"
		@close="handleClose"
	>
		<el-scrollbar class="opearteDialog-scroll" ref="opearteDialogScroll">
			<el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="120px" label-position="top" >
				<template v-if="staticPath === '/'">
					<el-form-item label="课程定价" prop="price">
						<div :class="classNames + '_from_item_con'" v-disabled="readOnly(ruleFormObj.dy_product_status === 2)">
							<el-input placeholder="支持小数点后两位" v-model="ruleForm.price" @input="handlePrice"></el-input>
						</div>
					</el-form-item>
				</template>
				
				<el-form-item label="课程推广比例设置" prop="promotion" ref="promotion" label-position="left" v-if="institution == 0">
					<div>
						<div>
							<el-radio-group v-model="promotionFlag" @change="changePromotionFlag" :disabled="!tax">
								<el-radio :label="0">关闭</el-radio>
								<el-radio :label="1">开启</el-radio>
							</el-radio-group>
						</div>
						<template v-if="promotionFlag">
							<div style="display:flex">
								<span style="white-space: nowrap;margin-right: 12px;color: #606266">豆包平台达人分佣:</span>
								<el-input placeholder="课程推广比例设置" v-model="ruleForm.promotion" maxlength="3" :disabled="!tax" @input="handlePromotion('promotion')">
								</el-input>
							</div>
							<div style="font-size: 12px;color: #888a95;line-height: 17px;margin-top: 10px;">
								例:某讲师课程定价100元,设置课程推广比例为20,平台抽走10%,平台达人推广该讲师课程可获得100*(1-10%)*20%=18元,讲师获得72元,平台获得10元。
							</div>
						</template>
					</div>
				</el-form-item>
				<el-form-item label="课程同步抖音任务台" prop="is_push_livetask" ref="is_push_livetask" v-if="staticPath === '/'">
					<div>
						<el-switch
							v-model="ruleForm.is_push_livetask"
							:active-value='1'
							:inactive-value='2'
						>
						</el-switch>
						<span style="font-size: 12px;line-height: 17px;color:#bdb2c8;display:block" v-if="ruleForm.is_push_livetask === 2">
							若开启课程同步抖音任务台,讲师课程将推送至抖音任务台,抖音官方任务台达人将可以分销推广该课程,获取对应收益益。
							</span>
						<template v-if="ruleForm.is_push_livetask === 1">
							<div style="display:flex">
								<span style="white-space: nowrap;margin-right: 12px;color: #606266">抖音任务台达人分佣:</span>
								<el-input placeholder="只允许填写整数（限制20%～80%）" v-model="ruleForm.livetask_percent" maxlength="3" @input="handlePromotion('livetask_percent')">
								</el-input>
							</div>
						</template>
					</div>
				</el-form-item>
				<el-form-item label="豆包红包" prop="red_custom_money" ref="red_custom_money" label-position="left">
					<div>
						<el-radio-group v-model="ruleForm.is_red">
							<el-radio :label="2">关闭</el-radio>
							<el-radio :label="1">开启</el-radio>
						</el-radio-group>
						<div v-if="ruleForm.is_red==1" style="display: flex">
							<div class="red-border">
								<el-select v-model="ruleForm.red_type" placeholder="请选择">
									<el-option
										v-for="item in baoSelect"
										:key="item.value"
										:label="item.label"
										:value="item.value">
									</el-option>
								</el-select>
							</div>
							<el-input prop="red_custom_money"  @input="handleRed" v-if="ruleForm.red_type==1" v-model="ruleForm.red_custom_money" style="width: 200px;margin-left: 30px;" placeholder="请输入合理的红包金额"></el-input>
						</div>
						<div v-if="ruleForm.red_type==1&&ruleForm.is_red==1" style="font-size: 12px;color: #888a95;line-height: 17px;margin-top: 10px;">
							红包金额需为正整数。
						</div>
						<div v-if="this.ruleForm.price !== ''" style="font-size: 12px;color: #888a95;line-height: 17px;margin-top: 10px;">
							提示：豆包红包不会影响用户的实际支付价格，用户实际支付价格以课程定价为准。
						</div>
					</div>
				</el-form-item>
				<el-form-item label="虚拟购买数" prop="counts" ref="counts">
					<template slot="label">
						<span>虚拟购买数</span>
						<span style="color:#B9B9BA">范围 1~100000</span>
					</template>
					<div>
						<el-input placeholder="请输入手机端显示的购买数" v-model="ruleForm.counts" @input="handleVirPuCh">
						</el-input>
					</div>
				</el-form-item>
				<el-form-item label="防录屏" prop="is_watermark" label-position="left">
					<div>
						<el-radio-group v-model="ruleForm.is_watermark">
							<el-radio :label="2">关闭</el-radio>
							<el-radio :label="1">开启</el-radio>
						</el-radio-group>
						<div style="font-size: 12px;color: #888a95;line-height: 17px;margin-top: 10px;">
							提示：开启后，学员在观看课程时可防止其录屏。
						</div>
					</div>
				</el-form-item>
				<el-form-item label="是否限购" prop="is_quota" label-position="left">
					<div>
						<el-radio-group v-model="ruleForm.is_quota">
							<el-radio :label="1">开启限购</el-radio>
							<el-radio :label="2">不开启限购</el-radio>
						</el-radio-group>
						<div style="font-size: 12px;color: #888a95;line-height: 17px;margin-top: 10px;">
							提示：默认开启只能买一单，不开启可购买多单。
						</div>
					</div>
				</el-form-item>
				<el-form-item label="商品编码" prop="product_code">
					<template slot="label">
						<span>商品编码</span>
					</template>
					<div>
						<el-input placeholder="请输入商品编码" v-model="ruleForm.product_code" :maxlength="180" @input="handleproductCode">
						</el-input>
					</div>
				</el-form-item>
				
				<el-form-item label="更新状态" label-position="left">
					<el-radio-group v-model="ruleForm.renew_status" size="mini">
						<el-radio-button label="1">更新中</el-radio-button>
						<el-radio-button style="margin-right:10px;" label="2">已完结</el-radio-button>
					</el-radio-group>
				</el-form-item>

				<el-form-item v-if="staticPath == '/wx/'" label="课程链接" label-position="left">
					<div v-if="!wxDbzxLink.length">
						<el-button @click="createLink" type="primary" size="mini">生成链接</el-button>
					</div>
					<div v-else>
						<span>{{ wxDbzxLink }}</span>
						<el-button type="primary" size="mini" style="margin-left: 6px;" @click="copyLink(wxDbzxLink)">复制</el-button>
					</div>
				</el-form-item>

				<el-form-item v-if="staticPath == '/'" label="关键词" label-position="left">
					<p style="color: red;font-size: 12px;line-height: 18px;margin: -15px 0 15px;">
						解释：用户在抖音搜索信息检索系统中输入的词语或短语。这些关键词用于帮助用户找到他们感兴趣的内容或信息
					</p>
					<el-input type="textarea" rows="5" resize="none" v-model="ruleForm.keywords" placeholder="请输入关键词，多个关键词用逗号隔开。若未填写则默认取：课程名,讲师名。"></el-input>
				</el-form-item>

			</el-form>
		</el-scrollbar>
		<span slot="footer" class="dialog-footer">
			<el-button @click="cancel">取 消</el-button>
			<el-button type="primary" @click="sure">确 定</el-button>
		</span>
	</el-dialog>
</template>
<script>
import { mapActions, mapState } from 'vuex'
import quillEditor from '@/components/quillEditor/quillEditor.vue'
import uploads from '@/components/newUpload/upload.vue'
export default {
	props: {
		value: {
			type: Boolean,
			default: true
		},
		id: {
			type: Number,
			default: 0
		},
		itemobj:{
			type: Object,
			default:()=>{}
		}
	},
	data() {
		const  validateVirtualRed = (rule, value, callback) => {
			if ((value < 1 || value >=1000)&&this.ruleForm.red_type==1&&this.ruleForm.is_red==1) {
				callback(new Error('红包金额需大于0小于1000'))
			}
			callback();
		}
		const  validateVirtualPurchase = (rule, value, callback) => {
			if (value < 1 || value > 100000) {
				callback(new Error('范围1~100000'))
			}
			callback();
		}
		let validatePrice = (rule, value, callback) => {
				if (value === '') {
					callback(new Error('请输入课程定价'))
				} else {
					if(this.ruleForm.cate_id == 15 && value>0) {
						callback(new Error('免费专区课程定价只能为0'))
					} 
					if(this.staticPath === '/') {
						const limitPrice = [10, 10000]
						value * 100 <= limitPrice[0] * 100 || value * 100 >= limitPrice[1] * 100  ? callback(new Error(`课程单价需大于${limitPrice[0]}元,小于${limitPrice[1]}元`)) : ''
					} else {
						value * 100 > 1000000  ? callback(new Error('课程单价最高为1万')) : ''
					}
					callback();
				}
			}
		return {
			classNames: '',
			tax: true, // 是否可修改推广设置 
			opeartionFlag: false,
			promotionFlag: 0,  // 推广设置推广比例开关
			institution: localStorage.getItem('institution'),// 是否显示推广设置 
			ruleForm: {
				is_push_livetask: 1, // 同步抖音任务台
				livetask_percent: 50, // 同步抖音任务台-抖音达人分佣比例
				promotion: '', // 推广设置推广比例
				is_red: 1, // 红包是否开启
				red_type:0,//红包种类
				red_custom_money:'',//自定义红包数额
				counts: 1, // 虚拟购买数
				is_watermark: 2, //水印状态
				product_code: '', //商品编码
				renew_status: 2,
				price: '',
				keywords: '', // 关键词
				is_quota: 1, // 是否限购:1=是,2=否
			},
			wxDbzxLink: '', // 微信豆包知道、豆包甄选课程链接
			rules: {
				is_push_livetask: [
					{
						required: false,
						trigger: 'change',
						validator: (rule, value, callback) => {
							if(value === 1 && this.staticPath === '/') {
								if(this.ruleForm.livetask_percent === '') {
									callback(new Error('请输入抖音达人分佣比例'))
								} 
								if(this.ruleForm.livetask_percent< 20 || this.ruleForm.livetask_percent>80) {
									callback(new Error('抖音达人分佣比例只能为20%-80%'))
								}
							}
							callback()
						}
					}
				],
				promotion: {
					required: true,
					validator: (rule, value, callback) => {
						if(this.promotionFlag == 1 &&  (value <0 || value> 100)) {
							callback(new Error('推广比例只能为0%-100%'))
						}
						callback()
					},
					trigger: 'change'
				},
				red_custom_money: [{
					validator : validateVirtualRed,
					required: false,
					trigger: 'change'
				}],
				counts: [{
					validator : validateVirtualPurchase,
					required: false,
					trigger: 'change'
				}],
				is_watermark:[{
					required: false,
					message: '请选择水印状态',
					trigger: 'change'
				}],
				price: [{
						required: true,
						validator: validatePrice,
						// message: '请输入课程定价',
						trigger: 'blur'
				}],
			},
			baoSelect:[ // 红包类型列表
				{
					label: '平台默认红包',
					value: 0
				}, {
					label: '自定义红包',
					value: 1
				}
			],
			ruleFormObj: {},
		}
	},
	components:{
		'quill-editor': quillEditor,
		uploads,
	},
	directives: {
		disabled: {
			bind(el, data) {
				const { value } = data
				if(value) {
					el.style.position = 'relative'
					let divElement = document.createElement('div')
					divElement.style = 'position:absolute;top:0;left:0;bottom: 0;right: 0;z-index: 100;cursor: not-allowed'
					el.appendChild(divElement)
				}
			},
			update(el, data) {
				const { value } = data
				if(value) {
					el.style.position = 'relative'
					let divElement = document.createElement('div')
					divElement.style = 'position:absolute;top:0;left:0;bottom: 0;right: 0;z-index: 100;cursor: not-allowed'
					el.appendChild(divElement)
				}
			}
		}
	},
	created() {
		if(this.staticPath === '/') {
			this.getMerchantTax()
		}
		this.$watch(() => this.value, (news) => {
			if(news) {
				this.getProductSettingDetail()
			}
		})
		this.ruleFormObj = JSON.parse(JSON.stringify(this.ruleForm))
	},
	computed: {
		...mapState('login', ['userInfo']),
		readOnly() {
				return (flag) => {
					return this.$route.name === 'PreivewColumn' || flag
				}
			}
	},
	methods: {
		...mapActions('dataCenter', ['merchantTax']),
		...mapActions('class', ['productSetting', 'productSettingDetail', 'getWxDbzxLinkAPI']),
		// 生成链接
		async createLink(){
			let res = await this.getWxDbzxLinkAPI({product_id: this.id})
			this.wxDbzxLink = res.url
		},
		// 复制链接
		copyLink(copycontent){
			this.$copyText(copycontent).then(
				e=>{
					// console.log('复制成功：', e);
					this.$message({
						message: '复制成功',
						type: 'success'
					})
				},
				e=>{
					console.log('复制失败：', e);
					this.$message.error('复制失败')
				}
			)
		},
		// 获取回显数据
		async getProductSettingDetail() {
			let res = await this.productSettingDetail({id: this.id })
			for (const key in this.ruleForm) {
				if(key === 'promotion') {
					this.promotionFlag = (res.data[key]-0 >= 0) ? 1: 0
					this.ruleForm[key] = res.data[key]
				} else {
					this.ruleForm[key] = res.data[key]
				}
			}
		},
		cancel() {
			this.$emit('input', false)
		},
		// 抖音中关键词中文逗号换成英文逗号
		changeKeywordText(){
			if(this.staticPath == '/'){
				this.ruleForm.keywords = this.ruleForm.keywords.replace(/[，,]/g,',')
			}
		},
		sure() {
			// this.ruleForm.material_type==1?(this.ruleForm.material=this.material_product):(this.ruleForm.material = this.material_Url)
			this.$refs.ruleForm.validate(async (valid, errorList) => {
				if(valid) {
					this.changeKeywordText()
					await this.productSetting({ ...this.ruleForm, id: this.id})
					this.$emit('input', false)
					this.$message({
						type: 'success',
						duration: 3000,
						message: '修改成功'
					})
				}
				for (const key in errorList) {
					this.$refs.opearteDialogScroll.wrap.scrollTop = this.$refs[key].$el.offsetTop
					break
				}
			})
		},
		// 监听课程推广比例设置
		changePromotionFlag(value) {
			if(value) { // 开启
				this.ruleForm.promotion = 0
			} else { // 关闭
				this.ruleForm.promotion = -1
			}
		},
		handlePromotion(type) { //抖音达人分佣规则
			this.ruleForm[type] = this.ruleForm[type].replace(/[^0-9]/g, '')
		},
		async getMerchantTax() { // 推广设置是否可以修改
			let res = await this.merchantTax()
			// this.tax = res.tax_status
			this.tax = res.can_op_promotion // true 可修改比例
		},
		handleRed() { // 红包金额规则
			this.ruleForm.red_custom_money = this.ruleForm.red_custom_money.replace(/[^0-9]/g, '')
			if (this.ruleForm.red_custom_money <= 0 ) {
				this.ruleForm.red_custom_money = this.ruleForm.red_custom_money.slice(0, this.ruleForm.red_custom_money.length - 1)
			}
		},
		handleVirPuCh() {
			this.ruleForm.counts = this.ruleForm.counts.replace(/[^0-9]/g, '')
			if (this.ruleForm.counts <= 0 || this.ruleForm.counts > 100000) {
				this.ruleForm.counts = this.ruleForm.counts.slice(0, this.ruleForm.counts.length - 1)
			}
		},
		handleproductCode(){
			const regs = /[^a-z|A-Z|0-9|\-|_]/g;
			this.ruleForm.product_code = this.ruleForm.product_code.replace(regs, "")
		},
		handleClose() {
			this.$emit('input', false)
		},
		handlePrice() {
				this.ruleForm.price = this.ruleForm.price.replace(/[^0-9.]/g, '')
				if (this.ruleForm.price.indexOf('.') > 0) {
					this.ruleForm.price = this.ruleForm.price.slice(0, this.ruleForm.price.indexOf('.') + 3)
				}
			},
	},
	watch: {
					// news.counts == 0 ? news.counts = 1 : news.counts
		// if(news.promotion) {
		// 				this.promotionFlag = 1
		// 			} else {
		// 				this.promotionFlag = 0
		// 			}
		// if(detailColumnObj.material_type==1){
		// 				this.material_product = detailColumnObj.material
		// 			}
		// 			if(detailColumnObj.material_type==2){
		// 				this.material_Url = detailColumnObj.material
		// 			}
		value: {
			immediate: true,
			handler(news) {
				this.opeartionFlag = news
				if(!news){
					this.wxDbzxLink = ''
				}
			}
		}
	}
}
</script>
<style lang="less">
	.opearteDialog-scroll {
		height: 500px;
		.el-scrollbar__wrap {
			overflow-x: hidden;
		}
	}
	.opearteDialog-wrap {
		.el-dialog__body {
			padding: 12px 18px;
		}
		.el-dialog__footer {
			padding: 0 18px 12px;
		}
	}
</style>
